module.exports = __webpack_public_path__ + "static/unitech-26b301a6e16bb19e43385493af202a14.gif";